/**
 * Couleurs DYNAMIQUES et mode sombre (2026-10-05).
 *
 * Une couleur venue des données ou d'une table (couleur d'un statut, d'une
 * étiquette…) est choisie pour être lisible sur fond blanc : en sombre, un
 * bleu #2563eb ou un rouge #ef4444 tombent sous 4,5:1 sur une carte (#2a2a2a).
 * `texteTheme` garde la couleur telle quelle en clair et, en sombre, la mêle
 * à 40 % de blanc : même teinte, contraste ≥ 5:1. Rien à faire côté appelant
 * au changement de thème : c'est `light-dark()` (cf. `color-scheme` dans
 * tokens.css) qui choisit.
 *
 *   <span style={{ color: texteTheme(statut.color) }}>…</span>
 *
 * ⚠️ Pour du TEXTE ou une bordure en CSS uniquement — jamais pour un
 * graphique (fill=, stroke=, recharts) ni un PDF : light-dark() n'y existe pas.
 */
export function texteTheme(couleur) {
  if (!couleur || typeof couleur !== 'string') return couleur;
  return `light-dark(${couleur}, color-mix(in srgb, ${couleur} 60%, white))`;
}
